import { SEO } from '@/components/common/SEO';
import { Hero } from '@/components/common/Hero';
import { Card } from '@/components/ui/Card';
import { PageLoader } from '@/components/ui/Spinner';
import { usePage } from '@/hooks/usePages';
import { useTranslation } from '@/features/i18n';

export function TermsPage() {
  const { data: page, isLoading } = usePage('terms');
  const { t } = useTranslation();

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <>
      <SEO
        title={page?.seo_title || t.legal.terms.title}
        description={page?.seo_description || t.legal.terms.seoDescription}
      />

      <Hero
        title={page?.title || t.legal.terms.title}
        subtitle={page?.subtitle || t.legal.terms.lastUpdated}
        size="sm"
      />

      <section className="py-16 lg:py-24 bg-white dark:bg-neutral-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card padding="lg">
            {page?.content_json ? (
              <div className="prose prose-lg dark:prose-invert max-w-none">
                {page.content_json.map((block, index) => (
                  <div
                    key={index}
                    dangerouslySetInnerHTML={{ __html: block.content }}
                  />
                ))}
              </div>
            ) : (
              <div className="prose prose-lg dark:prose-invert max-w-none">
                <h2>1. Aksept av vilkår</h2>
                <p>
                  Ved å bruke tjenestene til Dina i Bedrift AS ("Selskapet"), aksepterer du disse
                  vilkårene og betingelsene. Hvis du ikke aksepterer vilkårene, ber vi deg om ikke
                  å bruke våre tjenester.
                </p>

                <h2>2. Tjenestebeskrivelse</h2>
                <p>
                  Selskapet leverer digitale tjenester inkludert, men ikke begrenset til,
                  CRM-løsninger, apputvikling, webutvikling, SMS-markedsføring og AI-stemmeagenter.
                </p>

                <h2>3. Betaling og priser</h2>
                <p>
                  Priser for tjenester avtales skriftlig før oppstart av prosjekt. Fakturering
                  skjer i henhold til avtalt betalingsplan. Ved forsinket betaling påløper
                  forsinkelsesrente i henhold til forsinkelsesrenteloven.
                </p>

                <h2>4. Immaterielle rettigheter</h2>
                <p>
                  Alt innhold og materiell produsert av Selskapet forblir Selskapets eiendom
                  inntil full betaling er mottatt. Ved full betaling overføres avtalte rettigheter
                  til kunden.
                </p>

                <h2>5. Ansvarsbegrensning</h2>
                <p>
                  Selskapet er ikke ansvarlig for indirekte tap, tapt fortjeneste eller
                  følgeskader. Vårt maksimale ansvar er begrenset til det beløp kunden har betalt
                  for den aktuelle tjenesten.
                </p>

                <h2>6. Konfidensialitet</h2>
                <p>
                  Begge parter forplikter seg til å behandle konfidensiell informasjon med
                  forsiktighet og ikke dele den med tredjeparter uten skriftlig samtykke.
                </p>

                <h2>7. Oppsigelse</h2>
                <p>
                  Løpende avtaler kan sies opp med 30 dagers skriftlig varsel med mindre annet er
                  avtalt. Ved oppsigelse faktureres arbeid utført frem til oppsigelsesdato.
                </p>

                <h2>8. Tvister</h2>
                <p>
                  Eventuelle tvister skal søkes løst i minnelighet. Dersom dette ikke lykkes, skal
                  tvisten avgjøres ved Oslo tingrett etter norsk rett.
                </p>

                <h2>9. Endringer</h2>
                <p>
                  Selskapet forbeholder seg retten til å endre disse vilkårene. Endringer vil bli
                  varslet med rimelig frist og trer i kraft ved fortsatt bruk av tjenestene.
                </p>
              </div>
            )}
          </Card>
        </div>
      </section>
    </>
  );
}
